<template>
  <v-card class="d-flex flex-column align-center justify-center elevation-0 py-16" outlined>
    <img :src="TimeTableImage" alt="student-setting" />
    <span v-if="!createSchedule" class="mt-4">
      {{
        `Vui lòng cung cấp các thông tin ở trên,
 sau đó ấn [ Xem TKB ] để xem Thời khóa biểu của ${name} cụ thể `
      }}
    </span>
    <span v-else class="mt-4">
      {{
        `Vui lòng cung cấp các thông tin ở trên,
 sau đó ấn [ Chọn xếp ] để xếp Thời khóa biểu của lớp cụ thể `
      }}
    </span>
  </v-card>
</template>

<script>
import TimeTableImage from '@/assets/time-table-default.svg'

export default {
  props: {
    type: String,
    createSchedule: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      TimeTableImage
    }
  },
  computed: {
    name() {
      return this.type === 'class' ? 'lớp' : 'Giáo viên'
    }
  }
}
</script>

<style></style>
